import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import ServicesMarquee from '../components/ServicesMarquee'
import ServicesNav from '../components/ServicesNav'
import ServiceGallery from '../components/ServiceGallery'
import { Link } from 'react-router'
const Smm = () => {
  return (
    <>
    <Helmet>
      <title>Social Media Management - Om Softwares | SMM Services in Punjab</title>
      <meta name="description" content="Boost your brand with Om Softwares' social media management services. We create impactful strategies for Facebook, Instagram, LinkedIn, and Twitter to drive engagement and growth." />
      <meta property="og:title" content="Social Media Management - Om Softwares" />
      <meta property="og:description" content="Impactful social media strategies for Facebook, Instagram, LinkedIn, and Twitter." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/social-media-management" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Social Media Management - Om Softwares" />
      <meta name="twitter:description" content="Impactful social media strategies for Facebook, Instagram, LinkedIn, and Twitter." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
    <Breadcrumb name="Social Media Management"/>
    <div className="service-details pt-125 ">
            <div className="container">
                <div className="row mt-none-30 align-items-center">
                    <div className="col-lg-6 mt-30">
                        <div className="section-title">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Om Softwares - Best Digital Marketing Agency</span>
                            <h3 className="title xb-split-text split-in-right mb-15">Creating Impactful Social Media Strategies <span>with Om Softwares</span></h3>

                        </div>
                        <div className="service-single-content">
                            <p className="mb-40 wow fadeInUp" data-wow-duration=".7s">Our mission is to empower businesses by creating dynamic social media strategies that enhance engagement and brand visibility. We are committed to delivering innovative social media solutions that exceed our clients' expectations, fostering genuine connections with their audience.</p>
                            <p className="wow fadeInUp" data-wow-delay="200ms" data-wow-duration=".7s">
                            Our vision is to lead in social media management, recognized for our creative strategies, commitment to excellence, and ability to drive measurable results that amplify your brand's presence online.
                            </p>

                        </div>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="service-details_image">
                            <img className="ukiyo" data-u-speed="1.2" src="assets/img/about/social-media-management-hero.webp" alt="Om Softwares Social Media Management Services"/>
                        </div>
                    </div>
                </div>
                <div className="row pt-80">
                    <div className="col-lg-8">
                        <div className="sv-details mt-30">
                            <h3 className="sv-title">Effective social media management helps your brand connect with the <br/> audience, build engagement, and drive conversations <br/> without overwhelming your followers!</h3>
                            <ul className="sv-list">
                                <li>Creation of tailored social media strategies</li>
                                <li>Content creation and curation for different platforms</li>
                                <li>Community engagement and customer support</li>
                                <li>Analytics and performance tracking for continuous improvement</li>
                            </ul>

                        </div>
                    </div>
                    <div className="col-lg-4 mt-30">
                        <div className="sd-details">
                            <h3 className="sd-title">LOGO DESIGN</h3>
                           <p className="sd-content pb-60">Our vision is to lead in logo design, delivering creative, memorable, and professional logos that enhance brand identity. We are committed to excellence, ensuring your logo stands out and drives recognition while fostering customer trust and satisfaction.</p>

                            <Link to="/contact" className="sd-button">Let’s Talk <img src="assets/img/icon/SD-01.svg" alt=""/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="service_details-slider z-3 pt-130">
           
        <ServiceGallery img1="assets/img/searvice/sg_01.jpg" img2="assets/img/searvice/sg_02.jpg"
                        img3="assets/img/searvice/sg_03.jpg" img4="assets/img/searvice/sg_04.jpg"
                        img5="assets/img/searvice/sg_05.jpg" img6="assets/img/searvice/sg_01.jpg"/>
            <div className="container">
                <h3 className="sd-contents pt-125">Effective social media management connects your brand with your audience & <br/> drives engagement without overwhelming them. Bonus points for when it also <br/> sparks meaningful conversations & strengthens brand loyalty!</h3>

            </div>
        </section>
       
        <ServicesMarquee/>

        <ServicesNav prev="WEB DEVELOPMENT" next="DIGITAL MARKETING"/>
    </main>
    </>
  )
}

export default Smm
